import { Text, Box } from '@cad-arc';

export function GroupHeader({
    displayName,
    count,
}: {
    displayName: string;
    count: number;
}): React.ReactElement {
    return (
        <Box bg="surface.primary" w="full" py="2">
            <Text tabIndex={-1} variant="bodyMd" fontWeight="bold" color="secondary">
                {displayName} ({count})
            </Text>
        </Box>
    );
}
